import { useState } from "react";
import { useGlobalStore } from "../../contexts/globalStoreContext";
import { api } from "../../services";
import type { TotalSimulationResponse } from "../../services/APIService/types";

export const useFetchSimulation = () => {
	const { anticipationStore: store, authenticationStore: authStore } = useGlobalStore();
	const [load, isLoad] = useState(false);

	const getSimulation = async () => {
		if (load) {
			return;
		}
		isLoad(true);

		try {
			const offers: TotalSimulationResponse[] = [];
			const token = authStore.getToken() || "";
			// Primeira requisição para obter yearsInAdvance
			const firstRes = await api.getTotalSimulation(token, 10);
			const yearsInAdvance = firstRes.yearsInAdvance;
			offers.push(firstRes);

			// Monta array de promises para os anos restantes
			const promises = [];
			for (let i = yearsInAdvance - 1; i >= 1; i--) {
				promises.push(api.getTotalSimulation(token, i));
			}

			// Executa todas as requisições em paralelo
			const results = await Promise.allSettled(promises);

			results.forEach((res, i) => {
				if (res.status === "fulfilled") {
					offers.push(res.value);
				} else {
					console.warn(`Req ${i} falhou:`, res.reason);
				}
			});

			// Retorna ou salva as ofertas conforme sua necessidade
			return store.saveOffersSimulated(offers);
		} catch (error) {
			console.error(error);
			return;
		} finally {
			isLoad(false);
		}
	};

	return { getSimulation, load };
};
